import { Fancybox } from "@fancyapps/ui/dist/fancybox/fancybox.esm.js";
import "@fancyapps/ui/dist/fancybox/fancybox.css";

import Swiper, { Navigation, Pagination } from "swiper";

import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";

document.addEventListener("DOMContentLoaded", function (event) {
  new Swiper(".swiper-banner-principal", {
    watchSlidesProgress: true,
    spaceBetween: 0,
    slidesPerView: 1,
    loop: false,
    autoplay: {
      delay: 5000,
    },
    pagination: {
      el: ".swiper-pagination",
      clickable: true,
    },
    modules: [Pagination, Navigation],
  });

  new Swiper(".swiper-campanhas", {
    watchSlidesProgress: true,
    spaceBetween: 64,
    slidesPerView: 1,
    loop: false,
    autoplay: {
      delay: 5000,
    },
    pagination: {
      el: ".swiper-pagination-campanhas",
      clickable: true,
    },
    modules: [Pagination, Navigation],
  });

  new Swiper(".swiper-hemocentros-logos", {
    watchSlidesProgress: true,
    spaceBetween: 20,
    slidesPerView: 5,
    loop: true,
    autoplay: {
      delay: 500,
    },
    navigation: {
      nextEl: ".swiper-button-next",
      prevEl: ".swiper-button-prev",
    },
    breakpoints: {
      320: {
        slidesPerView: 1,
        spaceBetween: 10,
      },
      480: {
        slidesPerView: 2,
        spaceBetween: 20,
      },
      640: {
        slidesPerView: 3,
        spaceBetween: 20,
      },
      768: {
        slidesPerView: 4,
        spaceBetween: 20,
      },
      1024: {
        slidesPerView: 5,
        spaceBetween: 20,
      },
    },
    modules: [Pagination, Navigation],
  });

  new Swiper(".swiper-galeria", {
    watchSlidesProgress: true,
    spaceBetween: 20,
    slidesPerView: 1,
    loop: true,
    autoplay: {
      delay: 5000,
    },
    pagination: {
      el: ".swiper-pagination-galeria",
      clickable: true,
    },
    modules: [Pagination, Navigation],
  });
});
